import { ValueOf } from '../utilities/types';

const conflictFields = {
  ACTIVITIES: 'activities',
  ADDRESS: 'address',
  ALTERNATIVE_BENEFICIAL_OWNERS: 'alternativeBeneficialOwners',
  BENEFICIAL_OWNER: 'beneficialOwner',
  BENEFICIAL_OWNERS: 'beneficialOwners',
  CITIZENSHIP: 'citizenship',
  CITY: 'city',
  COMPANY_NAME: 'companyName',
  DATE_OF_BIRTH: 'dateOfBirth',
  EMAIL: 'email',
  EMPLOYMENT_STATUS: 'employmentStatus',
  FIRST_NAME: 'firstName',
  FORECASTED_TURNOVER: 'forecastedTurnover',
  INCOME: 'salary',
  INDUSTRY: 'industry',
  IS_FINANCIAL_INSTITUTION: 'isFinancialInstitution',
  LAST_NAME: 'lastName',
  LEGAL_FORM: 'legalForm',
  LISTED_FINANCIAL_MARKET: 'listedFinancialMarket',
  MERCHANT_CATEGORY_CODE: 'merchantCategoryCode',
  MIDDLE_NAME: 'middleName',
  OPERATION_START_DATE: 'operationStartDate',
  OTHER_LEGAL_FORM: 'otherLegalForm',
  OWNER_STRUCTURE: 'ownerStructure',
  PEP: 'pep',
  PHONE_NUMBER: 'phoneNumber',
  POSTAL_CODE: 'postalCode',
  PREVIOUS_TURNOVER: 'perviousTurnover',
  PRODUCTS: 'products',
  PURPOSE: 'purpose',
  REGISTRATION_NUMBER: 'organizationNumber',
  RESIDENCE: 'residence',
  ROLE: 'role',
  SIGNATORIES: 'signatories',
  SOURCE_OF_FUNDS: 'sourceOfFunds',
  SOURCE_OF_WEALTH: 'sourceOfWealth',
  STATE_OWNED: 'stateOwned',
  TAX_RESIDENCY: 'taxResidency',
  TIN: 'tin',
  TRANSACTION_MONITORING_THRESHOLD: 'transactionMonitoringThresholds',
  WEBSITE: 'website',
} as const;

export type ConflictFields = ValueOf<typeof conflictFields>;

export default conflictFields;
